import urlJoin from 'url-join';
import { connectedStore } from '../../store';
import config from '../../config';
import getExtensionVersionId from '../selectors/extension-version-id';

const composeExtensionAssetUrl = (slug, source) => {
  const store = connectedStore.get();
  const state = store.getState();
  const apiUrl = config.selectors.getServiceAPIUrl(state);
  const extensionVersionId = getExtensionVersionId(state, slug);

  return urlJoin(apiUrl, 'extension-versions', extensionVersionId, 'assets', source);
};

export default composeExtensionAssetUrl;
